import { LocaleUtil, StringUtil } from "@eres/core";
import React from "react";
import { DetailsKVProps } from "../types";
import { UIConfig } from "../EjariWebConfig";


export function DefaultDetailsKV( props: DetailsKVProps ) {
	let value = "-";
	if ( props.value ) {
		value = LocaleUtil.getLocalValue( props.value );
		if ( StringUtil.isEmptyStringOrNull( value ) ) {
			value = "-";
		}
	}
	const v = props.valueRenderer ? props.valueRenderer() : <span>{ value }</span>;
	return <div>
		<span>{ props.label }</span>
		{ v }
	</div>;
}

export default function ( props: DetailsKVProps ) {
	if ( UIConfig.DetailsKV ) {
		const DetailsKV = UIConfig.DetailsKV;
		return <DetailsKV { ...props }/>;
	}
	return <DefaultDetailsKV { ...props }/>;
}
